import moment from "moment";

export const isNotBlank = (val) => {
  return val !== "" && val !== null && !/^ +$/.test(val);
};

export const hasNoEmojis = (val) => {
  if (
    typeof val === "string" &&
    /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi.test(
      val
    )
  )
    return false;
  return true;
};

export const isPhoneNumber = (val) => {
  if (!val) {
      return true;
  }
  
  return /^(1|)?-?(\d{3})-?(\d{3})-?(\d{4})$/.test(val);
};

export const isEmail = (val) => {
  if (!val) {
      return true;
  }
  
  return (
    typeof val === "string" &&
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      val
    )
  );
};

export const isOnlyNumeric = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
  return (
    (typeof val === "string" || typeof val === "number") &&
    /^(\s*|\d+)$/.test(val)
  );
};

export const isFloating = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
  return (
    (typeof val === "string" || typeof val === "number") &&
    /^\d+(\.\d{1,2})?$/.test(val)
  );
};


export const isYesOrNo = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
  return ['yes', 'no', '1', '0', 'y', 'n'].indexOf(String(val).toLowerCase()) >= 0;
};

export const isLessThanOrEqualTo800 = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
    return Number(val) <= 800;
};

export const isLessThanOrEqualTo36= (val) => {
    if (val === null || val === '') {
        return true;
    }
    
    return Number(val) <= 36;
};


export const isValidGradYear = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
    return Number(val) >= 2020 && Number(val) <= 2099;
};

export const isValidDate = (val) => {
    if (val === null || val === '') {
        return true;
    }
    
    let allowedFormats = [
        'MM/DD/YYYY',
        'MM/DD/YY',
        'MM-DD-YYYY',
        'MM-DD-YY',
        'YYYY-MM-DD',
    ];
    
    return moment(val, allowedFormats, true).isValid();
};

export const hasNoAtSign = (val) => {
  if (val === null || val === '') {
      return true;
  }
  
  return !val.includes('@');
};

export const isValidAthleteName = (val) => {
  const regex = /(\d|[(),"/]|(\bcommitted\b)|\bcommit\b|\bcollege\b|\buniversity\b)/gi;
  return !(typeof val !== "string" || regex.test(val));
}